import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  createNotification,
  deleteNotification,
  notificationQueryKeys,
  updateNotification,
} from '@/entities/notification';
import { WORKFLOW_TYPE } from '@/types/workflowConst';

/**
 * Realtime Workflow 생성 mutation
 */
export function useCreateRealtimeMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.REALTIME]),
      });
    },
  });
}

/**
 * Realtime Workflow 수정 mutation
 */
export function useUpdateRealtimeMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.REALTIME]),
      });
    },
  });
}

/**
 * Realtime Workflow 삭제 mutation
 */
export function useDeleteRealtimeMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.REALTIME]),
      });
    },
  });
}
